import { Events } from './events';

type CaseMetadata = {
    preparedBy?: string;
};

const hasNonEmptyString = (value: unknown): value is string => {
    return typeof value === 'string' && value.length > 0;
};

const currentAuthor = (events: Events) => {
    const metadata = events.invoke('case.metadata') as CaseMetadata | undefined;
    const preparedBy = metadata?.preparedBy;
    return hasNonEmptyString(preparedBy) ? preparedBy : 'editor';
};

const stamp = (events: Events) => {
    return {
        author: currentAuthor(events),
        createdAt: new Date().toISOString()
    };
};

const withProvenance = <T extends { author?: string; createdAt?: string }>(events: Events, value: T): T & { author: string; createdAt: string } => {
    const stamped = stamp(events);

    return {
        ...value,
        author: hasNonEmptyString(value.author) ? value.author : stamped.author,
        createdAt: hasNonEmptyString(value.createdAt) ? value.createdAt : stamped.createdAt
    };
};

export { currentAuthor, stamp, withProvenance };
